import { render } from "./delivery-notice-count.vue?vue&type=template&id=39b34e74&scoped=true"
import script from "./delivery-notice-count.vue?vue&type=script&lang=js"
export * from "./delivery-notice-count.vue?vue&type=script&lang=js"

import "./delivery-notice-count.vue?vue&type=style&index=0&id=39b34e74&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b34e74"]])

export default __exports__